import Layout from 'features/shared/Layout';
import SolutionsShow from 'features/solutions/Show';

import { PageHeader } from '@frontendmentorio/design-system-v2';

export default function Page({ solution }) {
  return (
    <Layout
      description={`${solution.user.username}'s front-end solution for the ${solution.challenge.title} coding challenge on Frontend Mentor`}
      image={solution.challenge.heroImage}
      isIndexed={!solution.private}
      title={`Frontend Mentor | ${solution.title} coding challenge solution`}
      url={`https://www.frontendmentor.io/solutions/${solution.slug}`}
    >
      <PageHeader heading="Solution" />
      <SolutionsShow data={solution} />
    </Layout>
  );
}

export async function getServerSideProps({ params }) {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_REST_API_URL}/v3/solutions/${params.slug}`
  );

  if (!response.ok) return { notFound: true };

  const body = await response.json();

  return { props: { solution: body.data } };
}
